import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { generateServerVariables } from '@starsoft/common/utils';
import { useSearchParams } from '@starsoft/common/hooks';
import {
  setIsAdminEmbed,
  setIsAdminView,
  setSettings,
} from '@/lib/store/theme/actions';
import { deleteCookie, setCookie } from 'cookies-next';
import { CookiesKey } from '@starsoft/common/enums';

export function useSettingInjection() {
  const dispatch = useDispatch();
  const search = useSearchParams();
  const parentOrigin = new URL(process.env.NEXT_PUBLIC_ADMIN_URL || '').origin;

  const handleSettingInjection = useCallback(() => {
    const crossKeyCheck = search.get('crossKeyCheck');

    if (!crossKeyCheck) {
      return;
    }

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== parentOrigin) {
        return;
      }

      try {
        if (event.data?.type === 'SETTINGS_DATA') {
          const settings = event.data.settings;

          dispatch(setSettings(settings));
          dispatch(setIsAdminView(true));
          dispatch(setIsAdminEmbed(true));
          setCookie(CookiesKey.IsAdminView, 'true', {
            sameSite: 'strict',
            maxAge: 600,
          });

          //styles
          const styleElement =
            document.getElementById('setting-style') ||
            document.createElement('style');
          styleElement.id = 'setting-style';
          styleElement.innerHTML = `
            :root {
              ${generateServerVariables(settings)}
            }
          `;
          document.head.appendChild(styleElement);

          //font
          const fontElement = document.getElementById(
            'font-family-url',
          ) as HTMLLinkElement;

          if (fontElement) {
            fontElement.href = settings.fontFamily.url;
          }
        }
      } catch (error) {
        console.error('Error processing settings message:', error);
      }
    };

    window.addEventListener('message', messageHandler);

    // return () => {
    //   window.removeEventListener('message', messageHandler);
    //   deleteCookie(CookiesKey.IsAdminView);
    // };
  }, [dispatch, search, parentOrigin]);

  useEffect(handleSettingInjection, [handleSettingInjection]);
}
